import { Component, OnInit, OnDestroy } from '@angular/core';
import { EMPTY, Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { BroadcastingsService } from 'src/app/services/broadcastings-services/broadcastings.service';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-broadcastings-broadcastings-dashboard',
  templateUrl: './broadcastings-broadcastings-dashboard.component.html',
  styleUrls: ['./broadcastings-broadcastings-dashboard.component.scss']
})
export class BroadcastingsBroadcastingsDashboardComponent implements OnInit, OnDestroy {

  broadcastings;
  filterKey;
  noItemsConfig;
  viewDisposition = 'grid';
  getBroadcastingsSubscription: Subscription;
  refreshBroadcastingsSubscription: Subscription;
  searchBroadcastingsSubscription: Subscription;
  toggleBroadcastingsDispositionSubscription: Subscription;

  constructor(private broadcastingsService: BroadcastingsService,
    private snackbarService: SnackBarService,
    private headerBreadcrumbService: HeaderBreadcrumbService) {
      this.noItemsConfig = this.setNoItemsConfig();
    }

  ngOnInit() {
    this.setBreadcrumb();
    this.getBroadcastings();
    this.refreshBroadcastingsSubscription = this.broadcastingsService.refreshBroadcastingsListen().pipe(
      tap(o => this.getBroadcastings())
    ).subscribe();
    this.searchBroadcastingsSubscription = this.broadcastingsService.searchBroadcastingsListen().pipe(
      tap(o => this.filterKey = o)
    ).subscribe();
    this.toggleBroadcastingsDispositionSubscription = this.broadcastingsService.toggleBroadcastingsDispositionListen().pipe(
      tap(o => this.viewDisposition = o)
    ).subscribe();
  }

  public getBroadcastings() {
    this.getBroadcastingsSubscription = this.broadcastingsService.getBroadcastings().pipe(
      tap(o =>  this.broadcastings = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-photo-video', 'broadcastings-page.broadcastings', '/broadcastings', [new BRoute('broadcastings-page.broadcastings', '/broadcastings'), new BRoute('broadcastings-page.broadcastings')]));
  }

  private setNoItemsConfig() {
    return {
      description: 'broadcastings-page.broadcastings not found',
      action: '',
      lottieConfig: {
        path: 'assets/lottie-animations/empty-list.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
      }
    };
  }

  ngOnDestroy() {
    if (this.refreshBroadcastingsSubscription) { this.refreshBroadcastingsSubscription.unsubscribe(); }
    if (this.searchBroadcastingsSubscription) { this.searchBroadcastingsSubscription.unsubscribe(); }
    if (this.getBroadcastingsSubscription) { this.getBroadcastingsSubscription.unsubscribe(); }
  }
}

